// validates passwords by using critera collection
// with the following attributes:
//	message	- criteria description
//	regex   - regular expression of criteria for testing
// required parameters:
//	passwordCriteriasCollection - criteria collection
//	idPrefix - id prefix used to generate unique element id
define(function(require) {
    const CLASS_FAIL = 'rule-failed';
    const CLASS_SUCCESS = 'rule-passed';
    const CLASS_WAIT = 'rule-waiting';
    const DEFAULT_ID_PREFIX = 'passwordCriteria';
    const AvailableFeatures = require('civicsUtils/available_features');

    var PasswordValidator = function(passwordCriteriasCollection, idPrefix) {
        // initialize
        this.passwordCriteriasCollection = passwordCriteriasCollection;
        this.idPrefix = (idPrefix) ? idPrefix : DEFAULT_ID_PREFIX;

        // generate password criterias from collection
        this.passwordCriterias = [];
        this.setIdPrefix(this.idPrefix);
    };

	// define prototype functions
    $.extend(PasswordValidator.prototype, {
    	// accessors
        getCriterias: function() {
            return $.extend(true, [], this.passwordCriterias);
        },
        setIdPrefix: function(idPrefix) {
            this.passwordCriteriasCollection.each(function(model) {
              //only enabled password criterias will be included.
              if(AvailableFeatures.ISOPasswordRequirement()){
                if(model.get("enabled") == true){
                  var mod = _.extend({}, model.attributes, { id: this.idPrefix + this.passwordCriterias.length });
                  mod.ruleStatus = CLASS_WAIT;
                  this.passwordCriterias.push(mod);
                }
              } else {
                var mod = _.extend({}, model.attributes, { id: this.idPrefix + this.passwordCriterias.length });
                mod.ruleStatus = CLASS_WAIT;
                this.passwordCriterias.push(mod);
              }
            }.bind(this));
        },
        // functions
        validate: function(password, view, ignoreEmpty = false) {
            var isValid = true;
            _.each(this.passwordCriterias, function(criteria) {
                // check password
                var empty = ignoreEmpty ? 0 : _.isEmpty(password);
                var regex = new RegExp(criteria.regex);
                var newClass = empty ?  CLASS_WAIT : (regex.test(password) ? CLASS_SUCCESS : CLASS_FAIL);
                criteria.ruleStatus = newClass;
                if (newClass === CLASS_FAIL) {
                    isValid = false;
                }
                // change element class
                var cel = view.$el.find("#" + criteria.id);
                if (cel.length > 0) {
                    // replace class
                    cel.removeClass();
                    cel.addClass(newClass);
                }
            });
            return isValid;
        },
    });
    return PasswordValidator;
});
